/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { HealthRequestBuilderRequestsMetadata, type HealthRequestBuilder } from './health/index.js';
// @ts-ignore
import { SummaryRequestBuilderRequestsMetadata, type SummaryRequestBuilder } from './summary/index.js';
// @ts-ignore
import { TopByRevenueRequestBuilderRequestsMetadata, type TopByRevenueRequestBuilder } from './topByRevenue/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/customers
 */
export interface CustomersRequestBuilder extends BaseRequestBuilder<CustomersRequestBuilder> {
    /**
     * The health property
     */
    get health(): HealthRequestBuilder;
    /**
     * The summary property
     */
    get summary(): SummaryRequestBuilder;
    /**
     * The topByRevenue property
     */
    get topByRevenue(): TopByRevenueRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const CustomersRequestBuilderUriTemplate = "{+baseurl}/api/analytics/customers";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CustomersRequestBuilderNavigationMetadata: Record<Exclude<keyof CustomersRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    health: {
        requestsMetadata: HealthRequestBuilderRequestsMetadata,
    },
    summary: {
        requestsMetadata: SummaryRequestBuilderRequestsMetadata,
    },
    topByRevenue: {
        requestsMetadata: TopByRevenueRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
